import {FC, useState} from "react";
import {jwtDecode} from "jwt-decode";

interface JPGToPDFConverterProps {
    onBack?: () => void;
}

const JWTEncoder: FC<JPGToPDFConverterProps> = ({onBack}) => {

    const [token, setToken] = useState("");
    const [decoded, setDecoded] = useState("");


    const handlePaste = async () => {
        try {
            const clipboardText = await navigator.clipboard.readText();
            setToken(clipboardText);
        } catch (err) {
            alert("Unable to read clipboard.");
        }
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(decoded);
        } catch (err) {
            alert("Unable to copy.");
        }
    };
    const handleClear = () => {
        setToken("");
        setDecoded("");
    };

    function decodeJWT() {
        const decodedJWT=JSON.stringify(jwtDecode(token), null, 2);
        setDecoded(decodedJWT);
        console.log(decoded);
    }

    return (
        <div style={{maxWidth: 900, margin: "0 auto", padding: "40px"}}>
            {onBack && (
                <button
                    onClick={onBack}
                    style={{
                        background: "transparent",
                        border: "none",
                        color: "#2563eb",
                        fontSize: 14,
                        fontWeight: 600,
                        cursor: "pointer",
                        marginBottom: 24,
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        transition: "color 0.15s",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "#1d4ed8")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "#2563eb")}
                >
                    ← Back to Home
                </button>
            )}
            <h2>JWT Encoder / Decoder</h2>

            <h3>Original Token</h3>
            <textarea
                rows={10}
                value={token}
                onChange={(e) => setToken(e.target.value)}
            />
            <br/>
            <button onClick={() => decodeJWT()}>
                Decode
            </button>
            <div className="toolbar">
                <button onClick={handlePaste}>📋 Paste</button>
                <button onClick={handleCopy}>📄 Copy</button>
                <button onClick={handleClear}>🗑 Clear</button>
            </div>

            <h3>Decoded</h3>
            <textarea rows={20} value={decoded} onChange={(e) => setDecoded(e.target.value)}  />
            <br/>

        </div>
    );
}
export default JWTEncoder;
